import { PlanStack } from '@zapier/design-system-revenue/src/types';
import { BillingInterval } from '@zapier/design-system-revenue/src/graphql-types';
import { planIds } from './planIds';

const commonProps = {
  __typename: 'PlanV2' as 'PlanV2',
  amount: 0,
  allowCompanies: false,
  description: 'Anyone can automate their work. Start with the basics.',
  hasAutoReplay: false,
  hasPaths: false,
  hasMultiStepZaps: false,
  hasPremiumApps: false,
  hasTeams: false,
  hasMeteredBilling: false,
  tiers: [],
  isInPlanGroup: true,
  features: [
    {
      __typename: 'PlanFeature' as 'PlanFeature',
      name: 'Single-step Zaps',
      href: null,
      tooltip:
        'Single-step Zaps have one Trigger (e.g. new email lead) and one Action (e.g. add to my CRM).',
    },
  ],
  name: 'Free',
  tasks: 100,
  type: 'Free',
  zaps: 5,
  zapsRunInterval: 15,
};

export const freePlanStackMock: PlanStack = {
  __typename: 'PlanTaskGrouping',
  id: 'Free',
  plans: [
    {
      ...commonProps,
      interval: BillingInterval.year,
      id: planIds.FREE_YEARLY,
    },
    {
      ...commonProps,
      interval: BillingInterval.month,
      id: planIds.FREE_MONTHLY,
    },
  ],
  planType: 'Free',
};
